// 首页的store

import React, { useReducer, createContext, useContext } from 'react'

import { AdData } from './ad/interface'

interface IStore {
  /**
   * 首页的广告数据
   * undefined 代表未加载
   * null 代表没有广告数据
   */
  adData: AdData | null | undefined
}

interface ISetAdData {
  type: 'setAdData'
  payload: IStore['adData'] | null
}

type TAction = ISetAdData

interface StoreContext {
  state: Partial<IStore>
  dispatch(param: ISetAdData): void
}
const initState = {
  adData: undefined,
}
const HomeStoreContext = createContext<StoreContext>({
  state: initState,
  dispatch: () => {},
})

function reducer(state: Partial<IStore> = initState, action: TAction) {
  switch (action.type) {
  case 'setAdData':
    return {
      ...state,
      adData: action.payload || null,
    }
  default:
    return state
  }
}

const HomeStoreProvider = (props: {
  children: React.ReactNode
  value?: Partial<IStore>
}) => {
  const { children, value = {} } = props
  const [state, dispatch] = useReducer(reducer, initState)
  return (
    <HomeStoreContext.Provider
      value={{
        state: {
          ...state,
          ...value,
        },
        dispatch,
      }}
    >
      {children}
    </HomeStoreContext.Provider>
  )
}

function useAdData() {
  return useContext(HomeStoreContext).state.adData
}

export { HomeStoreProvider, HomeStoreContext, useAdData }
